import {
    EnumInfoUTypes,
    EnumLanguages,
    EnumLogLevel,
    EnumMFAMethods,
    EnumNotificationDeliveryOptions,
    EnumNotificationStatuses,
    EnumNotificationTemplateEditingMode,
    EnumPopupShowStatuses,
    EnumPrintingType,
    EnumSystemOptions,
    EnumUserLoginStatus,
    EnumYesNo,
    HistoryEventTypesEnum
} from '@core/framework/sysenums.enum';

export const Resources_HE =
{
    Pages:
    {
        login: 'התחברות למערכת',
        logout: 'התנתק',
        credentials_activity_status: 'מצב פעילות משתמשים',
        notificationshistory: 'דוח התראות שנשלחו',
        notification_servers: 'שרתי התראות',
        notification_dispatches: '$$$Notification dispatches',
        notification_templates: 'תבניות להתראות',
        notifications: 'התראות',
        system_options: 'הגדרות מערכת',
        credential_login_history: "דוח התחברויות משתמשים",
        request_history: "דוח פניות לשרת",
        credentials_report: 'דוח משתמשים',
        data_views: 'ניהול Views בסיס נתונים',
        menu: 'תפריט',
        credentials_creation: 'יצירת משתמשים חדשים',
        remote_request_history: "דוח בקשות יוצאות",
        NotificationViewComponent: 'התראה שנשלחה',
        PrintBoxDialogComponent: 'הדפסה',
        SignBoxDialogComponent: 'חתימה על מסמך',
        ImageBoxDialogComponent: 'תמונה',
        PhotoBoxDialogComponent: 'צילום',
        PasswordManageComponent: 'ניהול פרטי התחברות',
        CredentialsActivityStatusComponent: 'מצב פעילות משתמשים',
        NotificationsHistoryComponent: 'דוח התראות שנשלחו',
        PreviewDialogComponent: 'תצוגה מקדימה',
        NotificationDispatchComponent: '$$$Notification dispatch',
        NotificationDispatchListComponent: '$$$Notification dispatches',
        NotificationServerComponent: 'שרת התראות',
        NotificationServerListComponent: 'שרתי התראות',
        NotificationTemplateListComponent: 'תבניות להתראות',
        NotificationTemplateComponent: 'תבנית התראה',
        HtmlBoxDialogComponent: 'עורך HTML',
        NotificationTestDialogComponent: 'בדיקת התראות',
        NotificationPreviewDialogComponent: 'תצוגה מקדימה של התראות',
        SystemOptionsComponent: 'הגדרות מערכת',
        AddSystemOptionDialogComponent: 'הוסף הגדרה',
        BarcodeBoxDialogComponent: 'סרוק ברקוד/QR-code',
        CredentialLoginHistoryComponent: "דוח התחברויות משתמשים",
        RequestHistoryListComponent: "דוח פניות לשרת",
        RequestHistoryComponent: "פניה לשרת",
        WelcomeUserDialogComponent: "הודעת ברוכים הבאים",
        HistoryViewComponent: 'היסטוריית שינוים',
        SystemCredentialsComponent: 'דוח משתמשים',
        SystemCredentialsCreationComponent: 'יצירת משתמשים חדשים',
        WelcomeMessageConfigDialogComponent: 'הודעה על התחברות ראשונית למערכת',
        DataViewListComponent: 'ניהול Views בסיס נתונים',
        MenuButtonListComponent: 'תפריט',
        ShareDialogComponent: '$$$Share'
    },
    Lists:
    {
        Languages:
            [
                {
                    Value: EnumLanguages.Hebrew,
                    Text: "עברית"
                },
                {
                    Value: EnumLanguages.English,
                    Text: "אנגלית"
                }, 
                {
                    Value: EnumLanguages.Spanish,
                    Text: "ספרדית"
                },
            ],

        NotificationDeliveryOptions: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: "אימייל",
                ID: 0
            },
            {
                Value: EnumNotificationDeliveryOptions.SMS,
                Text: "הודעת SMS",
                ID: 1
            },
            {
                Value: EnumNotificationDeliveryOptions.WhatsApp,
                Text: 'הודעת WhatsApp',
                ID: 3
            }
        ],
        NotificationDispatchDeliveryOptions: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: "אימייל"
            },
            {
                Value: EnumNotificationDeliveryOptions.SMS,
                Text: "הודעת SMS"
            },
            {
                Value: EnumNotificationDeliveryOptions.WhatsApp,
                Text: 'הודעת WhatsApp'
            },
            {
                Value: EnumNotificationDeliveryOptions.PushMessage,
                Text: 'התראה באפליקציה'
            },
        ],
        NotificationTemplateEditingModes: [
            {
                Value: EnumNotificationTemplateEditingMode.None,
                Text: '$$$None',
                ID: 0,
                SortOrder: 1
            },
            {
                Value: EnumNotificationTemplateEditingMode.Preview,
                Text: '$$$Preview only',
                ID: 4,
                SortOrder: 2
            },
            {
                Value: EnumNotificationTemplateEditingMode.EditPrefix,
                Text: '$$$Edit prefix',
                ID: 1,
                SortOrder: 3
            },
            {
                Value: EnumNotificationTemplateEditingMode.EditBody,
                Text: '$$$Edit body',
                ID: 3,
                SortOrder: 4
            },
        ],
        UserCreationOptions: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: "אימייל",
                ID: 0
            },
            {
                Value: EnumNotificationDeliveryOptions.SMS,
                Text: 'טלפון',
                ID: 1
            }
        ],
        WelcomeDeliveryOptions: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: 'אימייל',
                ID: 0,
                SortOrder: 1
            },
            {
                Value: EnumNotificationDeliveryOptions.SMS,
                Text: 'הודעת SMS',
                ID: 1,
                SortOrder: 2
            },
            {
                Value: EnumNotificationDeliveryOptions.WhatsApp,
                Text: 'הודעת WhatsApp',
                ID: 3,
                SortOrder: 3
            },
            {
                Value: EnumNotificationDeliveryOptions.DontSend,
                Text: 'לא לשלוח',
                ID: 2,
                SortOrder: 4
            }
        ],
        NotificationTypes: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: "אימייל",
                SortOrder: 1,
                index: 0,
                text: "אימייל",
                Name: EnumNotificationDeliveryOptions.Email
            },
            {
                Value: EnumNotificationDeliveryOptions.SMS,
                Text: "הודעת SMS",
                SortOrder: 2,
                index: 1,
                text: "הודעת SMS",
                Name: EnumNotificationDeliveryOptions.SMS
            },
            {
                Value: EnumNotificationDeliveryOptions.PushMessage,
                Text: 'התראה באפליקציה',
                SortOrder: 3,
                index: 2,
                text: 'התראה באפליקציה',
                Name: EnumNotificationDeliveryOptions.PushMessage
            },
            {
                Value: EnumNotificationDeliveryOptions.WhatsApp,
                Text: 'הודעת WhatsApp',
                SortOrder: 4,
                index: 3,
                text: 'הודעת WhatsApp',
                Name: EnumNotificationDeliveryOptions.WhatsApp
            },
            {
                Value: EnumNotificationDeliveryOptions.Share,
                Text: '$$$Share',
                SortOrder: 4,
                index: 3,
                text: '$$$Share',
                Name: EnumNotificationDeliveryOptions.Share
            }
        ],
        NotificationStatuses:
            [
                {
                    Value: EnumNotificationStatuses.Draft,
                    Text: "טיוטה"
                },
                {
                    Value: EnumNotificationStatuses.Sending,
                    Text: "שליחה"
                },
                {
                    Value: EnumNotificationStatuses.Failure,
                    Text: "נכשל"
                },
                {
                    Value: EnumNotificationStatuses.Sent,
                    Text: "נשלח"
                },
            ],
        NotificationPredefinedSmtpServers: [
            {
                Text: "Office 365",
                SMTPServer: "smtp.office365.com",
                SMTPPort: 587,
                SMTPUseSSL: true
            },
            {
                Text: "Gmail",
                SMTPServer: "smtp.gmail.com",
                SMTPPort: 111,
                SMTPUseSSL: true
            },
            {
                Text: "SendGrid",
                SMTPServer: "smtp.sendgrid.com",
                SMTPPort: 111,
                SMTPUseSSL: false
            }
        ],
        NotificationPredefinedSmsServers: [
            {
                Text: "InforU",
                SMSEndpoint: "https://uapi.inforu.co.il/SendMessageXml.ashx",
                SMSToken: 111,
                SMSEndPointIsInforU: EnumInfoUTypes.InforU
            },
            {
                Text: "Unicell",
                SMSEndpoint: "http://api.soprano.co.il/",
                SMSToken: 222,
                SMSEndPointIsInforU: EnumInfoUTypes.Unicell
            }
        ],
        MFAMethods:
            [
                {
                    Value: EnumMFAMethods.None,
                    Text: "ללא"
                },
                {
                    Value: EnumMFAMethods.Email,
                    Text: "מייל"
                },
                {
                    Value: EnumMFAMethods.SMS,
                    Text: "SMS"
                },
                {
                    Value: EnumMFAMethods.WhatsApp,
                    Text: "WhatsApp"
                }
            ],
        ExportMenuItems: [
            {
                SortOrder: 0,
                Value: 1,
                Text: "אקסל"
            },
            {
                SortOrder: 1,
                Value: 2,
                Text: "הדפס"
            }
        ],
        PopupShowStatuses: [
            {
                Value: EnumPopupShowStatuses.None,
                Text: "ללא"
            },
            {
                Value: EnumPopupShowStatuses.ToShow,
                Text: "הצג"
            },
            {
                Value: EnumPopupShowStatuses.Showed,
                Text: "הוצג"
            }
        ],
        InfoUTypes: [
            {
                Value: EnumInfoUTypes.Unicell,
                Text: "Unicell"
            },
            {
                Value: EnumInfoUTypes.InforU,
                Text: "InforU"
            }
        ],
        SystemOptions: [
            {
                Value: EnumSystemOptions.AppNameHE,
                Text: 'שם בעברית'
            }, {
                Value: EnumSystemOptions.AppNameEN,
                Text: 'שם באנגלית'
            }, {
                Value: EnumSystemOptions.AppURL,
                Text: 'קישור למערכת'
            }, {
                Value: EnumSystemOptions.SessionTimeout,
                Text: 'משך זמן לניתוק סשן, דקות'
            }, {
                Value: EnumSystemOptions.SessionExpiry,
                Text: 'משך זמן להזדהות מחדש, דקות'
            }, {
                Value: EnumSystemOptions.EnableRequestLogging,
                Text: 'אפשר בקשת גישה'
            }, {
                Value: EnumSystemOptions.EnableRemoteLogging,
                Text: 'אפשר חיבור מרחוק'
            }, {
                Value: EnumSystemOptions.ShowExpiredTimeoutAlert,
                Text: 'הצג תוקף התחברות למערכת'
            }, {
                Value: EnumSystemOptions.ShowAlmostExpiredTimeoutAlert,
                Text: 'הצג תוקף התחברות למערכת שעומד לפוג'
            }, {
                Value: EnumSystemOptions.IsSupportedCredentialsManagement,
                Text: 'תמיכה בניהול אישורים'
            }, {
                Value: EnumSystemOptions.IsSupportedUserWelcome,
                Text: 'תמיכה בהקמת משתמשים חדשים'
            }, {
                Value: EnumSystemOptions.IsSupportedPasswordChange,
                Text: 'תמיכה בשינוי סיסמא לאחר הזדהות'
            }, {
                Value: EnumSystemOptions.IsSupportedPasswordRecovery,
                Text: 'תמיכה בשחזור סיסמא ששכחתי'
            }, {
                Value: EnumSystemOptions.IsSupportedLoginByOTP,
                Text: 'אפשר חיבור ב-OTP'
            }, {
                Value: EnumSystemOptions.IsSupportedLoginByPassword,
                Text: 'אפשר חיבור באמצעות סיסמא'
            }, {
                Value: EnumSystemOptions.IsAutoCreateCredentials,
                Text: 'צור משתמש במערכת באופן אוטומטי בחיבור ראשון דרך OTP'
            }, {
                Value: EnumSystemOptions.AutoCreateCredentialsType,
                Text: 'סוג משתמש ליצירה אוטומטית'
            }, {
                Value: EnumSystemOptions.IsRequireTaxNumberForOTP,
                Text: 'בדוק מספר ח.פ בהזדהות עם OTP'
            }, {
                Value: EnumSystemOptions.PasswordChangeIntervalDays,
                Text: 'תדירות החלפת סיסמה (ימים)'
            }, {
                Value: EnumSystemOptions.PasswordComplexityLen,
                Text: 'מורכבות סיסמה - מספר תווים מינימאלי'
            }, {
                Value: EnumSystemOptions.PasswordComplexityMinChars,
                Text: 'מורכבות סיסמה - מספר אותיות מינימאלי'
            }, {
                Value: EnumSystemOptions.PasswordComplexityMinDigits,
                Text: 'מורכבות סיסמה - מספר ספרות מינימאלי'
            }, {
                Value: EnumSystemOptions.BadLoginAttemptBeforeLock,
                Text: 'מספר ניסיונות התחברות כושלים לפני נעילת משתמש'
            }, {
                Value: EnumSystemOptions.BadLoginAttemptsCheckIntervalMinutes,
                Text: 'חלון זמן לבדיקת מספר ניסיונות התחברות, דקות'
            }, {
                Value: EnumSystemOptions.BadLoginAttemptLockouIntervalMinutes,
                Text: 'משך נעילת משתמש לאחר ניסיון התחברות כושל, דקות'
            }, {
                Value: EnumSystemOptions.XFrameOptions,
                Text: 'אפשרויות חסימת XFrame'
            }, {
                Value: EnumSystemOptions.IsDeployedBehindLoadBalancer,
                Text: 'התקנה מאחורי Load Balancer או Proxy'
            }, {
                Value: EnumSystemOptions.IsSupportNotificationMethodEmail,
                Text: 'שליחה של הודעות מערכת באמצעות האימייל'
            }, {
                Value: EnumSystemOptions.IsSupportNotificationMethodSMS,
                Text: 'שליחה של הודעות מערכת באמצעות SMS'
            }, {
                Value: EnumSystemOptions.IsSupportNotificationMethodWhatsApp,
                Text: 'שליחה של הודעות מערכת באמצעות WhatsApp'
            }, {
                Value: EnumSystemOptions.RetentionPeriodRequests,
                Text: 'מספר ימים לשמירת בקשות שהתקבלו'
            }, {
                Value: EnumSystemOptions.RetentionPeriodRemoteRequests,
                Text: 'מספר ימים לשמירת בקשות שנשלחו'
            }, {
                Value: EnumSystemOptions.RetentionPeriodNotifications,
                Text: 'מספר ימים לשמירת התרעות שנשלחו'
            }, {
                Value: EnumSystemOptions.RetentionPeriodSessions,
                Text: 'מספר ימים לשמירת לוג סישנים'
            }, {
                Value: EnumSystemOptions.SessionFingerprintFreezeTimeout,
                Text: '$$$Session Fingerprint Freeze Timeout (mins)'
            },
        ],
        UserLoginStatuses: [
            {
                Value: EnumUserLoginStatus.All,
                Text: "הכל"
            },
            {
                Value: EnumUserLoginStatus.Success,
                Text: "הצליח"
            },
            {
                Value: EnumUserLoginStatus.Failure,
                Text: "נכשל"
            }
        ],
        IsSuccessStatuses: [
            {
                Value: true,
                Text: "הצליח"
            },
            {
                Value: false,
                Text: "נכשל"
            }
        ],
        HistoryEventTypesEnum: [
            {
                Value: HistoryEventTypesEnum.FieldChange,
                Text: "שינוי ערך"
            },
            {
                Value: HistoryEventTypesEnum.RowAdded,
                Text: "נוספה שורה"
            },
            {
                Value: HistoryEventTypesEnum.RowDeleted,
                Text: "שורה נמחקה"
            },
            {
                Value: HistoryEventTypesEnum.Special,
                Text: "Special"
            }
        ],
        YesNo:
            [
                {
                    Value: EnumYesNo.Yes,
                    Text: 'כן'
                },
                {
                    Value: EnumYesNo.No,
                    Text: 'לא'
                }
            ],
        PageTypes: [
            {
                Value: EnumPrintingType.None,
                Text: '$$$None'
            },
            {
                Value: EnumPrintingType.Report,
                Text: '$$$Report'
            },
            {
                Value: EnumPrintingType.Entity,
                Text: '$$$Entity'
            }
        ],
        LogLevels: 
        [
            {
                Value: EnumLogLevel.Warning,
                Text: 'Warning'
            },{
                Value: EnumLogLevel.Info,
                Text: 'Info'
            },{
                Value: EnumLogLevel.Error,
                Text: 'Error'
            },
        ]
    },
    Translations:
    {
        lblLanguage: "שפה",
        lblUserName: "שם משתמש",
        lblPassword: "סיסמה",
        titleLogin: "כניסה למערכת",
        btnLogin: "כניסה למערכת",
        btnLogout: 'התנתק',
        btnChangePassword: 'שנה סיסמה',
        btnContactUs: "צור קשר",
        btnRecoverPassword: 'שכחתי סיסמה',
        lblSaveCredentials: 'שמור פרטי הזדהות',
        titleLogout: "נותקת מהמערכת",
        titleLogoutLong: "נותקת מהמערכת בהצלחה.",
        titleLogoutLast: "הינך מועבר למסך הכניסה",
        titleSessionExpiredTitle: "ניתוק עקב חוסר פעילות",
        titleSessionExpired: "נותקת מהמערכת עקב חוסר פעילות או שינוי בפרטי המשתמש בשרת. אנא בצע כניסה מחודשת למערכת",
        titleChangePasswordTitle: "שינוי סיסמה",
        titleChangePassword: "בחר סיסמה חדשה העומדת בדרישות המורכבות שהוגדרו על ידי מנהל המערכת",
        titleChangePasswordTitle2: "שינוי סיסמה שפג תוקפה",
        titleException: "שגיאת מערכת",
        titleExceptionLong: "אירעה שגיאה בלתי צפויה במערכת\nפרטי השגיאה מופיעים מטה - אנא העבר אותם למנהל המערכת",
        titleComingSoonTitle: "בקרוב! גם זה יפותח..",
        titlePasswordChanged: 'הסיסמה הוחלפה בהצלחה. אנא השתמך בסיסמה החדשה על מנת להכנס מחדש למערכת',
        titleIdentification: 'הזדהות',
        titlePasswordEntry: 'הזנת סיסמה חדשה',
        titleRecoverPasswordTitle: 'שחזור סיסמה שנשכחה',
        titleWelcomePasswordTitle: 'כניסה ראשונית למערכת',
        titleRecoverPassword1: 'הקלד את שם המשתמש',
        titleRecoverPassword2: 'באפשרותך לשחזר סיסמה שנשכחה, אם יש לך גישה לאימייל או לטלפון שמוגדר בחשבון משתמש שלך',
        titleRecoverPassword3: 'על מנת לבחור סיסמא חדשה, יש להקליד את הקוד אימות שנשלח אלייך באמצעי שבחרת',
        titleRecoverPassword4: 'בחר סיסמה חדשה העומדת בדרישות המורכבות שהוגדרו על ידי מנהל המערכת',
        titleWelcomePassword2: 'ברוך הבא למערכת. יש להזין את שם המשתמש והקוד הסודי שנשלח אלייך על מנת לעבור לבחירת הסיסמה',
        titleWelcomePassword3: "בחר סיסמה חדשה העומדת בדרישות המורכבות שהוגדרו על ידי מנהל המערכת. סיסמה זו תשמש אותך מעכשיו על מנת להיכנס למערכת",
        btnReEntry: "כניסה מחודשת",
        genOK: 'אישור',
        genYes: "כן",
        genNo: "לא",
        genCancel: "ביטול",
        genNoData: "אין נתונים להצגה",
        genPrint: 'הדפס',
        genSign: 'חתום',
        genReset: 'נקה',
        genTakePhoto: 'צלם',
        genSavePhotos: 'שמור תמונות',
        genDownload: 'הורד',
        msgSignHere: 'אנא צייר את חתימתך בתוך המלבן',
        msgSignatureRequired: 'הינך חייב לחתום כאן על מנת להמשיך',
        msgPasswordsDontMatch: 'הסיסמאות לא תואמות, אנא נסה שנית',
        errorNetwork: "שגיאת תקשורת לשרת - בדוק את חיבור הרשת",
        errorSessionExpired: "נותקת עקב חוסר פעילות",
        errorUserInvalid: "פרטי המשתמש השתנו. אנא התחבר מחדש למערכת",
        errorNotInitialized: "לא ניתן להכנס למערכת כיוון שלא נטענו ההגדרות \n אנא טען את הדף מחדש",
        errorUnexpected: "@@@שגיאה לא צפויה בשרת@@@: {0}",
        errorUnauthorized: "המשתמש אינו מורשה לבצע פעולה זו",
        errorPasswordExpired: 'הסיסמה שהזנת פג תוקפה. יש להזין סיסמה חדשה',
        msgFinishEditing: "יש לשמור את השורה הנוכחית לפני הוספת שורה חדשה",
        errorUserNameNotFound: "המשתמש לא קיים",
        errorIsNotExistsPhoneAndEmail: "לא מוגדר טלפון או מייל למשתמש זה. צור קשר עם התמיכה",
        errorSessionIsFrozen: "$$$Session is frozen due using the same credential on another device",
        lblDay1: "ראשון",
        lblDay2: "שני",
        lblDay3: "שלישי",
        lblDay4: "רביעי",
        lblDay5: "חמישי",
        lblDay6: "שישי",
        lblDay7: "שבת",
        lblDay1s: "א'",
        lblDay2s: "ב'",
        lblDay3s: "ג'",
        lblDay4s: "ד'",
        lblDay5s: "ה'",
        lblDay6s: "ו'",
        lblDay7s: "ש'",
        msgSuccess: "הפעולה הסתיימה בהצלחה",
        msgNotPerformed: "לא ניתן לסיים את הפעולה",
        lblTimes: 'פעמים',
        lblUser: "משתמש רגיל",
        btnCancelDocument: 'בטל מסמך',
        lblBy: 'ע"י',
        titleCreatedBy: 'נוצר על ידי',
        titleCreated: 'נוצר',
        titleCreatedAt: 'נוצר ב',
        titleAgo: 'לפני',
        lblAgo: 'לפני',
        lblSearch: 'חיפוש',
        lblCloseSearch: 'סגור חיפוש',
        lblColumnChooser: 'בחירת עמודות',
        lblColumnHiding: 'מצב גלילה',
        lblShowGridFilter: 'הפעל סינון מתקדם',
        lblHideGridFilter: 'הסתר סינון מתקדם',
        lblExcel: 'ייצוא לאקסל',
        lblPdf: 'ייצוא ל PDF',
        lblViewList: 'הצג בתור רשימת כרטיסיות',
        lblViewGrid: 'הצג בתור טבלה',
        lblDisplayUserName: 'שם משתמש',
        lblLastUseDate: 'תאריך פעולה אחרונה',
        lblLastUseBefore: 'פעולה אחרונה לפני',
        progressIndicator: 'מעביר נתונים.. אנא המתן',
        lblUpdated: 'עודכן',
        lblNoSorting: '- ברירת מחדל -',
        lblVersion: 'גרסה',
        lblDateIsNull: "התאריך ריק",
        lblDateApproximate:"{1} {0} {2}",
        f702: "פחות מדקה",
        f703: "5 דקות",
        f704: "10 דקות",
        f705: "רבע שעה",
        f706: "חצי שעה",
        f707: "פחות משעה",
        f709: "שעה וחצי",
        f710: "שעתיים פלוס",
        f711: "{0} שעות",
        f712: "יום",
        f713: "יומיים",
        f714: "{0} ימים",
        f715: "שבוע פלוס",
        f716: "שבועיים פלוס",
        f717: "{0} שבועות",
        f718: "חודש פלוס",
        f720: "חודשיים",
        f721: "{0} חודשים",
        f722: "שנה פלוס",
        f723: "שנתיים פלוס",
        f724: "{0} שנים",
        f725: "פחות מיום",
        lblOldPassword: 'סיסמה ישנה',
        lblNewPassword1: 'סיסמה חדשה',
        lblNewPassword2: 'אימות סיסמה',
        lblRecoveryPhone: 'טלפון לשליחת קוד אימות',
        lblRecoveryEmail: 'אימייל לשליחת קוד אימות',
        btnSendNotificationDispatch: '$$$Send',
        btnSendRecoveryCode: 'שלח קוד לאימות',
        btnCheckUserName: 'שחזר סיסמה',
        btnBackToLogin: '$$$Back to login page',
        lblRecoveryType: 'אופן שיחזור סיסמה',
        lblRecoveryToken: 'קוד אימות סודי',
        btnResend: 'שלח שנית',
        btnSaveChanges: 'שמור פרטי הזדהות',
        btnGeneratePassword: 'סיסמה חדשה',
        btnCreateCredentials: 'צור משתמש',
        btnUnlockUser: 'שחרר משתמש נעול',
        lblDisplayUsername: 'שם משתמש לתצוגה',
        lblDisplayUserDescription: 'תאור משתמש לתצוגה',
        lblCredentialsNotExist: 'המשתמש טרם הוקם',
        lblPendingWelcome: 'נשלחה בקשה והמשתמש טרם הצטרף',
        titleUserInformation: 'פרטי משתמש',
        errorMaxSizeUploadError: 'חלק מהקבצים שנבחרו עוברים את הגודל המקסימאלי של {0} מגה, ולא יועלו',
        msgFileSizeRestriction: 'גודל הקובץ המקסימאלי הינה {0} מגה',
        btnSelectFiles: 'בחר קבצים',
        btnMakePhoto: 'צלם תמונה',
        lblAttachFileSize: 'גודל',
        lblFilters: 'סינונים',
        lblAt: 'ב',

        lblObjectName: 'שם אובייקט',
        lblIsOverride: 'בוצע קיסטום',
        lblValidation: 'תקין',
        lblDViewsDBDuration: 'זמן תגובה מקורי',
        lblXViewsDBDuration: 'זמן תגובה לאחר קיסטום',
        lblCheckPerformance: 'בדוק ביצועים',
        lblValidateViews: 'בדוק תקינות מבנה',
        lblViewError: '$$$Error',

        lblLoginOTPSendMethod: 'שלח סיסמה חד-פעמית באמצעות',
        lblLoginOTPEmail: 'אימייל לשליחת סיסמה חד-פעמית',
        lblLoginOTPPhone: 'טלפון לשליחת SMS עם סיסמה חד-פעמית',
        lblLoginOTPOTP: 'סיסמה חד-פעמית',
        lnkLoginByOTP: 'הזדהות באמצעות סיסמה חד-פעמית',
        msgNotificationSent: 'הסיסמה נשלחה',
        btnLoginOtpSendOtp: 'שלח סיסמה',
        lnkLoginByPassword: 'כניסה עם שם משתמש וסיסמה',

        lblApply: 'החל',
        lblTaxNumber: 'ח.פ/תעודת זהות',

        lblIsActive: 'פעיל',
        lblEmail: 'אימייל',
        lblPhone: 'טלפון',
        lblIsPendingWelcome: 'ממתין להתחברות ראשונית',
        lblIsOnline: 'אונליין',
        lblIsLockedOut: 'נעול',
        lblCreateCredentials: 'צור משתמש',
        lblCredentialFilter: '$$$Credential Filter',

        msgRouteNotFound: 'נתיב שגוי',
        btnReload: 'טען מחדש',
        lblHideColumn: 'הסתר עמודה',
        lblShowHiddenColumns: 'הצג את כל העמודות',

        lblName: "שם",
        lblDescription: "תיאור",

        msgLoading: "מעדכן נתונים.. אנא המתן",
        lblSentDate: "תאריך שליחה",
        lblSentBy: "נשלח על ידי",
        lblEntryID: "מספר",
        lblFromAddress: "מכתובת",
        lblFromDisplayAddress: "שם שולח",
        lblAddress: "כתובת",
        lblSubject: "כותרת",
        lblMailBody: "תוכן המייל",
        lblDeliveryOption: "אופן שליחה",
        lblSendNotificationBy: "שלח הודעות באמצעות",
        lblUsernameCreationOption: 'מתן שם משתמש לפי',
        lblStatus: "סטאטוס",
        lblToAddress: "כתובת",
        lblCCAddress: "העתק ל",
        lblBccAddress: "העתק מוסתר ל",
        lblFailureDescription: "הודעת שגיאה",
        lblNotificationTemplate: "שם תבנית",
        lblFrom: "מ",
        lblUntil: "עד ",
        lblSessionAlmostExpiredTitle: "החיבור שלך יפוג בקרוב",
        lblSessionAlmostExpiredPrompt: "המערכת זיהתה חוסר פעילות ותנתק אותך בקרוב",
        lblSessionExpiredTitle: "החיבור למערכת פג",
        lblSessionExpiredPrompt: "החיבור שלך פג עקב חוסר פעילות. הינך מועבר לדף הכניסה",
        lblFirstDate: "תאריך ראשון",
        lblLastDate: "תאריך אחרון",
        lblDate: "תאריך",
        lblAdd: "הוסף",
        lblClear: "נקה",
        lblCompactMode: "תצוגה קומפקטית",

        lblNotificationContent: "תוכן ההתראה",
        lblGeneral: "כללי",
        lblOptions: "אפשרויות",
        lblCustom: "הגדרות מיוחדות",

        lblMFACode: "קוד חד-פעמי",
        titleMFACodeOnEmailSent: "סיסמה חד-פעמית נשלחה אלייך למייל. תזין אותו בשדה למטה",
        titleMFACodeOnPhoneSent: "סיסמה חד-פעמית נשלחה אלייך לנייד. תזין אותו בשדה למטה",

        lblMFAMethod: "אימות דו-שלבי",

        Month_1: "ינואר",
        Month_2: "פברואר",
        Month_3: "מרץ",
        Month_4: "אפריל	",
        Month_5: "מאי",
        Month_6: "יוני",
        Month_7: "יולי",
        Month_8: "אוגוסט",
        Month_9: "ספטמבר",
        Month_10: "אוקטובר",
        Month_11: "נובמבר",
        Month_12: "דצמבר",
        lblExport: "ייצוא",
        lblCredentialType: "סוג משתמש",
        lblIsRestrictByIP: "הגבל לפי כתובת IP",
        lblIsExcludeFromMFA: "החרג כתובת מ מאימות דו-שלבי",
        lblIPRangeStart: "מכתובת IP",
        lblIPRangeEnd: "עד כתובת IP",
        lblIPErrorMessage: "כתובת ה IP חייבת להיות במבנה &#34;000.000.000.000&#34;",
        msgIPRangesIsEmpty: "יש לבחור כתובת אחת לפחות",
        msgIPRangeIsEmpty: "יש להזין כתובת IP חוקית",
        msgPasswordMinLength: "הסיסמה חייבת להיות באורך מינימאלי של {0} תווים",
        msgPasswordMinCountDigits: "הסיסמה חייבת להכיל מינימום של {0} ספרות",
        msgPasswordMinCountLetters: "הסיסמה חייבת להכיל מינימום של {0} אותיות באנגלית",
        msgPasswordComplexityRequirement: "הסיסמא חייבת להיות באורך מינימאלי של {0} תווים, ולהכיל לפחות {1} ספרות ו {2} אותיות באנגלית",
        errorOnlyImageAllowed: "ניתן לבחור רק תמונות",
        btnClose: "סגור",
        lblPhoto: "תמונה",

        lblDragAndDrop: "ניתן לגרור ולשחרר קבצים לכאן",
        errorRequiredMessage: "שדה חובה",
        titleDuplicate: "שכפל",
        lblAllNotifications: "כל ההתראות",

        lblSMTPServer: "שרת SMTP",
        lblSMTPPort: "פורט SMTP",
        lblSMTPUserName: "שם משתמש ל SMTP",
        lblSMTPPassword: "סיסמא ל SMTP",
        lblSMTPUseSSL: "השתמש בחיבור SSL",
        lblSMSEndpoint: "כתובת שרת SMS",
        lblSMSUserName: "שם משתמש ל SMS",
        lblSMSPassword: "סיסמא ל SMS",
        lblSMSToken: "טוקן ל SMS",
        lblSMSEndPointIsInforU: "ספק SMS",

        titleTemplateInformation: "מידע על תבנית התראה",
        titleEmailInformation: "הגדרות מייל",
        lblFromEmail: "שלח מכתובת אימייל",
        lblFromEmailDisplay: "שלח מ שם",
        titlePhoneInformation: "הגדרות SMS",
        lblNotificationServer: "שרת התראות",
        lblFromPhone: "שלח SMS מטלפון",
        lblSMSBody: "תוכן ההודעה",
        titlePushMessagesInformation: "הגדרות התראה באפליקציה",
        lblPushMessageBody: "תוכן ההתראה",
        lblHTMLBody: "גוף HTML",
        btnSave: 'שמור',
        titleDelete: 'מחק',
        lblUseDefault: 'השתמש בברירת מחדל',
        lblNoUnreadMessages: 'אין התראות חדשות',
        lblTo: 'אל',
        lblPushMessageContent: 'תוכן ההתראה',
        lblSmsMessageContent: 'תוכן ההודעה',
        lblIsAutomatic: 'נשלח אוטומטית',
        lblSystem: 'הודעת מערכת',
        lblPopupShowStatus: 'סטאטוס התראה קופצת',
        lblEmailContent: 'תוכן אימייל',
        btnShowInEditor: 'הצג בעורך HTML',
        titleLeavePageConfirmation: 'המידע שהזנת לא יישמר. האם ברצונך להמשיך?',
        btnLogOff: 'התנתק',
        btnStayConnected: 'הישאר מחובר',
        btnGoToHomePage: 'עבור לעמוד הבית',
        lblReadDate: 'תאריך צפייה',
        msgDeleteNotificationTemplateQuestion: 'ייתכן ותבנית זו בשימוש על ידי המערכת. האם ברצונך למחוק אותה?',
        lblNotificationServerWrong: 'הגדרות שרת ההתראות אינן תקינות. בדוק אותן ונסה שנית',
        lblMIDIsMissing: "חסר קוד MID",
        lblEnterMID: "הכנס קוד MID חדש.",
        btnTestServer: 'בדוק שרת',
        btnShowPreview: "תצוגה מקדימה",
        lblIsServer: "שרת",
        lblIsClient: "קליינט",
        lblModuleName: "מודול",
        lblLogin: "Login",
        lblFramework: "Framework",
        lblOption: "הגדרה",
        lblValue: "ערך",
        lblSectionName: "סעיף",
        lblAddOption: 'הוסף הגדרה',
        msgOptionAlreadyExists: 'ההגדרה כבר קיימת',
        msgOptionEmpty: 'הגדרה {0} ריקה',
        lblBadLogin: 'הזדהות נכשלה',
        msgRemoveOption: "האם אתה בטוח שברצונך למחוק את האפשרות '{0}'?",
        titleEmailConfiguration: "תצורת אימייל",
        titleSMSConfiguration: "תצורת SMS",
        msgDeleteNotificationServerQuestion: "ניתן להשתמש בשרת הודעות באפליקציה. האם אתה בטוח שברצונך למחוק אותו?",
        msgNoData: "אין נתונים",
        lblEmailHeader: "כותרת מייל",
        lblConfigure: "הגדר",
        lblDefaultFromAddressForInforU: "Test",
        lblDefaultFromAddressForUnicel: "0509999999",
        lblInforUFromPhoneValidationTooltip: "יש להקליד מספר טלפון שנמצא ברשימת White-list במערכת או שם שולח באנגלית בלבד, עד 11 תווים",
        lblNotifications: "התראות",
        lblMinimize: "צמצם",
        lblShowMore: "הצג עוד",
        titleWhatsAppInformation: "תבנית לשליחת WhatsApp",
        lblWhatsAppBody: "תוכן הודעה ב-WhatsApp",
        lblWhatsAppApiKey: "WhatsApp Api Key",
        lblWhatsAppEndpoint: "WhatsApp Endpoint",
        titleWhatsAppConfiguration: "הגדרות WhatsApp",
        titleNotificationDispatchList: "$$$Notification dispatch list",
        titleNotificationServerList: "שרת התראות",
        titleNotificationTemplateList: "תבנית התראות",

        lblPoweredBy: "Powered by Menahel4U",
        titleChooseOption: "בחר אפשרות",
        titleWebAPIAllowedIPs: "כתובות IP מותרות",
        lblIpAddress: "כתובת IP",
        lblLoginDate: "תאריך חיבור",
        lblPrint: "הדפסה",
        lblDateFrom: 'מתאריך',
        lblDateTo: 'עד תאריך',
        msgCouldNotStartVideoError: 'מצלמה אינה זמינה',
        msgCameraPermissionDenied: 'אין הרשאת גישה למצלמה',
        lblCameraModeVideo: 'וידאו',
        lblCameraModePhoto: 'תמונה',
        titlePreview: 'תצוגה מקדימה',
        msgLogoutQuestion: 'האם אתה בטוח שברצונך להתנתק?',
        lblGroupPanel: 'קיבוץ עמודות',
        lblExpandAll: 'הרחב הכל',
        lblMultiEmailError: 'ערך לא חוקי, השתמש בסמל ; על מנת להפריד בין המיילים',
        msgPhotoMinCountError: 'הספירה המינימלית היא {0}',
        msgPhotoMaxCountError: 'הספירה המקסימלית היא {0}',
        lblRestoreDefaultView: "שחזר תצוגת ברירת מחדל",
        lblStartDate: "תאריך התחלה",
        lblDuration: "משך זמן",
        lblController: "קונטרולר",
        lblMethod: "שיטה",
        lblStatusCode: "קוד סטטוס",
        lblRequestData: "נתוני בקשה",
        lblQueryString: "פרמטרים ב URL",
        lblBody: "תוכן בקשה",
        lblResponse: "תוכן תשובה",
        msgTextCopied: "טקסט הועתק",
        lblCopy: "העתק",
        btnGoToLoginHistory: "עבור לדוח התחברויות",
        btnGoToRequestsHistory: "עבור לדוח פניות לשרת",
        btnGoToCredentialsReport: "עבור לדוח משתמשים",
        btnManageCredentials: "נהל פרטי התחברות",
        btnWelcomeUser: "שליחת הודעת ברוך-הבא",
        lblTestFromPhone: "מטלפון",
        lblNewValue: "ערך חדש",
        lblOldValue: "ערך ישן",
        lblFieldCaption: "שדה",
        lblDocumentCaption: " מסך",
        lblAction: "פעולה",
        lblHistoryLineAdded: "{0} - שורה מספר {1} נוספה.",
        lblHistoryLineRemoved: "{0} - שורה מספר {1} נמחקה.",
        lblHistoryLineNumber: "{0} - שורה מספר {1}",
        lblHistory: "היסטורית שינוים",
        lblHistoryNotFound: "לא נמצאו שינויים.",
        lblHistoryChangeAdded: "{0} {1} נוצר",
        lblHistoryChangeRemoved: "{0} {1} נמחק",
        msgLoadingPDF: 'טוען קובץ PDF...',
        lblImpersonatedBy: 'בוצעה התחזות ע"י',
        lblIsUserCustomTemplate: "תבנית שבוצעו בה התאמות מיוחדות",
        msgIsUserCustomTemplateEnable: "אם אפשרות העריכה תופעל, תוכל לערוך את התבנית, אך במקרה של עדכון גרסה עתידי, המערכת לא תוכל לעדכן תבנית זו באופן אוטומטי במידה ויהיו בה שינויים.",
        btnEnableEditable: "הפעל אפשרות לעריכה",
        btnDisableEditable: "בטל אפשרות לעריכה",
        msgScreenSizeChangedRefresh: '$$$Screen size is changed. Please refresh browser window.',
        msgOrientationChangedRefresh: '$$$Orientation is changed. Please refresh browser window.',
        lblNotAssigned: "- לא משוייך -",
        msgNotificationSentTo: ' הקוד נשלח ל {0}',        
        lblDeliveryMethod: '$$$Delivery Method',
        lblNotificationDispatch: '$$$Notification Dispatch',
        lblRecipients: '$$$Recipients',
        lblPreview: '$$$Preview',
        msgRecipientsAreEmpty: '$$$You have to add at least one recipient',
        lblCreatedBy: 'נוצר על ידי',
        btnCancelNotifications: '$$$Cancel notifications',
        lblCancelNotificationsPrompt: '$$$You are going to cancel unread Push notifications. Do you want to proceed?',
        lblNotificationMessage: '$$$Notification Message',
        lblIsDeleted: '$$$Deleted',
        lblShareMethodEmail: '$$$Email',
        lblShareMethodSms: '$$$SMS',
        lblShareMethodWhatsapp: '$$$WhatsApp',
        lblShareMethodPrint: '$$$Print',
        lblShare: '$$$Share',
        lblEntityType: '$$$Entity type',
        lblPageName: '$$$Page',
        btnSend: '$$$Send',
        lblChooseTemplate: '$$$Choose template',
        lblShareMethodDownload: '$$$Download',
        lblShareMethodShare: '$$$Share',
        lblUploadCrystalTemplate: '$$$Upload crystal tempalte',
        lblNotificationTemplateEditingMode: '$$$Body editing mode',
        msgShareNotificationTemplateNotFoundError: '$$$Notification templates are not configured for this page',
        btnShare: 'Share',
        msgNotificationTemplatePrefixNotFoundError: '$$$ $PrefixBody$ param is missing',
        lblPrefixBody: '$$$Prefix body',
        lblIsSharePdf: '$$$Share PDF',
        lblFileNameFormat: '$$$File name format',
        lblEntityBindingPageType: '$$$Bind to',
        titleEntityBindingInformation: '$$$Entity binding',
        msgNotificationTemplateFileMissingError: '$$$Crystal report template is missing',
        lblSharedFile: '$$$Shared file',
        msgNotificationTemplateEmptyError: '$$$Cannot save empty template',
        lblIsSupportEmail: '$$$Support Email',
        lblIsSupportSMS: '$$$Support SMS',
        lblIsSupportWhatsapp: '$$$Support Whatsapp',
        lblIsSupportPush: '$$$Support push',
        lblIsSupportSharing: '$$$Support sharing',
        lblIsShareByEntities: '$$$Share by entities',
        ttlLogs: "$$$Logs",
        lblObjectType: "$$$Object type",
        lblObjectID: "$$$Object ID",
        lblLevel: "$$$Level",
        lblHeader: '$$$Header',
    }
};


